module.exports = __webpack_public_path__ + "img/user-9.63aca5da.png";